// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/assets/images/subs-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2714%27 height=%2714%27 viewBox=%270 0 14 14%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Crect width=%2714%27 height=%2714%27 rx=%272%27 fill=%27%2306EFC5%27/%3E%3Cpath d=%27M10.765 4.20474C11.0661 4.48915 11.0797 4.96383 10.7953 5.26497L6.54526 9.76497C6.40613 9.91228 6.21332 9.99703 6.01071 9.99993C5.8081 10.0028 5.61295 9.92361 5.46967 9.78033L3.21967 7.53033C2.92678 7.23744 2.92678 6.76257 3.21967 6.46967C3.51256 6.17678 3.98744 6.17678 4.28033 6.46967L5.98463 8.17397L9.70474 4.23503C9.98915 3.9339 10.4638 3.92033 10.765 4.20474Z%27 fill=%27%23242424%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subs .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0px;
}

.No-subs .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 90%;
  height: 90%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0px;
}

.sw .react-switch-bg {
  height: 22px !important;
  width: 50px !important;
}

.sw .react-switch-handle {
  height: 20px !important;
  width: 20px !important;
}

.subs .modal-fullscreen {
  height: auto !important;
  width: 100vw !important;
  max-width: none !important;
  margin: 0 !important;
}

.contact-sales {
  color: var(--Turquoise, #06EFC5);
  font-family: Urbanist;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.897px;
  padding: 10px;
}

.bg-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 60px;
}

.title {
  color: var(--White, #FFF);
  text-align: center;
  font-family: Urbanist;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1px;
}

.cross {
  color: var(--White, #FFF);
  font-size: 20px;
  margin-left: auto;
  cursor: pointer;
}

/* .sub-row {
  align-items: center;
} */

.sub-row img {
  width: 95px;
}

.plan {
  color: var(--White, #FFF);
  text-align: center;
  font-family: Urbanist;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 1px;
  margin-top: 10px;
}

.mon {
  color: #FFF;
  font-family: Urbanist;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.897px;
}

.react-switch-bg {
  border: 1.4px white solid;
}

.sub-box {
  width: 270px;
  height: 100%;
  border-radius: 8.966px;
  border: 0.897px solid rgba(255, 255, 255, 0.10);
  background: rgba(255, 255, 255, 0.10);
  /* backdrop-filter: blur(2.689655303955078px); */
  padding: 20px;
  margin-left: 10px;
  margin-right: 10px;
}

.type-box {
  border-radius: 3.586px;
  border: 0.897px solid var(--White, #FFF);
  padding: 8px 12px;
}

.type-box-s {
  border-radius: 3.586px;
  border: 0.897px solid var(--Turquoise, #06EFC5);
  padding: 8px 12px;
  background-color: var(--Turquoise, #06EFC5);
}

.type-box div {
  color: var(--White, #FFF);
  text-align: center;
  font-family: Urbanist;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.897px;
}

.type-box-s div {
  color: #000000;
  text-align: center;
  font-family: Urbanist;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.897px;
}

.input-w {
  position: relative;

  label {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    opacity: 1;
    border: 1.5px solid rgb(255 255 255 / 40%);
    border-radius: 4px;
    cursor: pointer;

    &:after {
      content: "";
      background-size: auto;
      background-repeat: no-repeat;
      background-position: center;
      width: 18px;
      height: 18px;
      display: inherit;
      top: -0.5px;
      position: relative;
      left: -0.6px;
    }
  }

  input {
    visibility: hidden;

    &:checked {
      ~label {
        &:after {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        }
      }
    }
  }

  &.myradio {
    label {
      border-radius: 50%;

      &::after {
        border-radius: 50%;
        width: 15px;
        height: 15px;
        top: 1px;
        left: 1px;
        position: relative;
      }
    }

    input {
      visibility: hidden;

      &:checked {
        ~label {
          &:after {
            background: #0defc5;
          }
        }
      }
    }
  }
}

.price_nav {
  color: var(--Turquoise, #06EFC5);
  text-align: center;
  font-family: Urbanist;
  font-size: 35px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.897px;
}

.price-strike_nav {
  color: var(--Gray-6, #F2F2F2);
  text-align: center;
  font-family: Urbanist;
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.897px;
  text-decoration: line-through;
}

.time {
  color: rgba(255, 255, 255, 0.80);
  text-align: center;
  font-family: Urbanist;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.897px;
}

.off {
  color: #06EFC5;
  text-align: center;
  font-family: Urbanist;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.897px;
}

.center {
  align-items: center;
  display: flex;
  justify-items: flex-end;
  justify-content: end;
}

.hr {
  width: 90%;
  height: 3px;
  flex-shrink: 0;
  border-radius: 3.586px 3.586px 0px 0px;
  background: var(--Turquoise, #06EFC5);
  filter: blur(0px);
  margin-left: -20px;
}

.list-item {
  color: #FFF;
  font-family: Urbanist;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.list ul li ::marker {
  display: none !important;
}

.check_nav_sub {
  width: 100%;
  height: 100%;
}

.list-row {
  align-items: center;
  display: flex;
  justify-items: flex-end;
}

.list-add {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 40px;
}

.button1 {
  width: 100%;
  height: 50px;
  flex-shrink: 0;
  border-radius: 8.966px;
  border: 0.897px solid #06EFC5;
  background: linear-gradient(89deg, #242424 -261.85%, rgba(36, 36, 36, 0.00) 98.43%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* .button1Active {
  width: 100%;
  height: 50px;
  flex-shrink: 0;
  border-radius: 8.966px;
  border: 0.897px solid #06EFC5;
  background: var(--Turquoise, #06EFC5); 
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
} */
.button1Active {
  width: 100%;
  height: 50px;
  flex-shrink: 0;
  border: 0.9px solid #06EFC5;
  border-radius: 8.97px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  font-weight: 500;
  background-color: transparent;
}
.button1Active:hover{
  background: var(--Turquoise, #06EFC5);
  color: #000000;
}

.btn-txt {
  color: var(--ds-neural-03, #FFF);
  text-align: center;
  font-family: Urbanist;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.14px;
}


.btn-continue {
  border-radius: 10px;
  background: #06EFC5;
  /* filter: blur(2px); */
  display: flex;
  width: 40%;
  height: 56px;
  padding: 13px 49px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  box-shadow: 0px 2px 24px 0px rgba(16, 155, 255, 0.24);
  cursor: pointer;
}

.cont {
  color: #100027;
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
}

.cards-row {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}

.justify-cent {
  justify-content: center;
}

.noSub {
  width: 500px;
  font-size: 16px;
  color: #FFFFFF;
  font-weight: 500;
}

@media screen and (min-width:750px) and (max-width:900px) {
  .cards-row {
    justify-content: unset;
    overflow: auto;
  }
}

@media screen and (min-width:350px) and (max-width:740px) {
  .cards-row {
    justify-content: unset;
    overflow: auto;
  }

  .bg-img {
    padding: 20px;
  }

  .justify-cent {
    justify-content: unset;
    align-items: center;
  }

  .mon {
    font-size: 15px;
  }

  .column-three {
    order: 3;
    margin-top: 10px;
  }

  .title {
    font-size: 26px;
    margin-top: 10px;
  }
}
@media screen and (max-width: 540px) {
  .main-div{
    display: block !important;
  }
  .col-md-5.col-6.p-0 {
      flex: 0 0 41.666667%;
      max-width: 100%;
  }
  .subs-year-text{
    margin-top: 0px !important;
    width: 140px !important;
    margin: 0px auto !important;
    padding-bottom: 20px !important;
  }
  .type-box{
    width: 100px !important;
  }
  .list-add{
    /* flex-direction: row; */
    margin-left: 5px;
    /* margin-top: 20px; */
  }
  .one{
    top: 62% !important;
    left: 24%;
    margin-left: -26px !important;
  }
  /* .navSubscription{
   width: 100% !important;
  } */
  .list-item{
    font-size: 13px;
  }
  .margn-top38{
    padding: 0px !important;
  }
}
.price-wise {
  color: rgba(255, 255, 255, 0.80);
  text-align: center;
  font-family: Urbanist;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.0625rem;
}

.navSubscription {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
  border-radius: 8.966px;
  border: 0.897px solid rgba(255, 255, 255, 0.10);
  background: rgba(255, 255, 255, 0.10);
  backdrop-filter: blur(2.689655303955078px);
}
.selectedSubscription {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
  border-radius: 8.97px;
  border: 0.9px solid #06EFC5;
  background: rgba(255, 255, 255, 0.10);
  backdrop-filter: blur(2.689655303955078px);
}
.promoCode{
  width: fit-content;
  margin: 10px auto;
}
.promo-code{
  background: transparent;
  border-color: #FFFFFF;
  border-radius: 5px; 
  background: rgba(255, 255, 255, 0.10);
  backdrop-filter: blur(2.689655303955078px);
  font-size: 16px;
  padding: 7px 30px;
  color: #FFFFFF;
}
.promo-code::placeholder{
  color: #9A9A9A;
}
input[type=radio]#radio { 
  width: 15px;
  height: 15px;
  accent-color: #06EFC5; 
} 
.heading{
  color: #06EFC5;
  font-size: 16px;
  width: fit-content;
  padding: 10px 0px 0px 10px;
}
.price-details{
  display: flex;
  justify-content: space-between;
  padding: 7px 0px;
}
.price-details-text{
  color: #FFF;
  font-size: 12px;
  font-weight: 300;
}
.btn_extra1 {
  color: var(--Turquoise, #06EFC5);
  text-align: center;
  font-family: Urbanist;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.165px;
}

.btn_extra2 {
  color: var(--Turquoise, #06EFC5);
  text-align: right;
  font-family: Urbanist;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
}

.navSubsCardTitle {
  margin-top: 1rem;
  color: var(--White, #FFF);
  font-family: Urbanist;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.10);
  backdrop-filter: blur(2.689655303955078px);
  margin-left: 10px;
}

.dotActive {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--Turquoise, #06EFC5);
  backdrop-filter: blur(2.689655303955078px);
  margin-left: 10px;
}

.divPointer {
  cursor: pointer;
}

.hrcard {
  width: 100%;
  height: 3px;
  flex-shrink: 0;
  border-radius: 3.586px 3.586px 0px 0px;
  background: var(--Turquoise, #06EFC5);
  filter: blur(0px);
  /* margin-left: -20px; */
}

/* .button1Active {
  width: 100%;
  height: 50px;
  flex-shrink: 0;
  border-radius: 8.966px;
  border: 0.897px solid #06EFC5;
  background: var(--Turquoise, #06EFC5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

} */

.btn-txtActive {
  color: black;
  text-align: center;
  font-family: Urbanist;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.14px;
}
.cancel-sub-box{
  background-color: #30273E;
  border-radius:12px;
}
.cancel-heading{
    color: var(--White, #FFF);
    text-align: center;
    font-family: Urbanist;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 1px;
}
.cancel-sub-subHeading{
  color: var(--White, #FFF);
  text-align: center;
  font-family: Urbanist;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1px;
  opacity: 0.8;
}
.cancel-sub-terms{
  color: var(--White, #FFF);
  text-align: center;
  font-family: Urbanist;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1px;
  opacity: 0.8;
}
.cancel-sub-terms span{
  text-decoration-line: underline;
}
.cancel-sub-btn-cancel{
  cursor:pointer;
  opacity: 0.44;
}
.cancel-sub-btn-confirm{
  cursor:pointer;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius:12px;
}
.cancel-sub-btn span{
  color: var(--White, #FFF);
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
}
.cancel-sub-btn span.confirm{
  color: #EB5757;

}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Settings/SubscriptionInNav.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yDAAqE;EACrE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,+CAA+C;EAC/C,qCAAqC;EACrC,gDAAgD;EAChD,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;;EAElB;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,UAAU;IACV,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;;IAEf;MACE,WAAW;MACX,qBAAqB;MACrB,4BAA4B;MAC5B,2BAA2B;MAC3B,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,WAAW;MACX,kBAAkB;MAClB,YAAY;IACd;EACF;;EAEA;IACE,kBAAkB;;IAElB;MACE;QACE;UACE,yDAAimB;QACnmB;MACF;IACF;EACF;;EAEA;IACE;MACE,kBAAkB;;MAElB;QACE,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,SAAS;QACT,kBAAkB;MACpB;IACF;;IAEA;MACE,kBAAkB;;MAElB;QACE;UACE;YACE,mBAAmB;UACrB;QACF;MACF;IACF;EACF;AACF;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,sCAAsC;EACtC,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,mFAAmF;EACnF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;;;;;;;;;;;GAYG;AACH;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;MACI,oBAAoB;MACpB,eAAe;EACnB;EACA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,+BAA+B;EACjC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,SAAS;IACT,6BAA6B;EAC/B;EACA;;KAEG;EACH;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,+CAA+C;EAC/C,qCAAqC;EACrC,0CAA0C;AAC5C;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,sCAAsC;EACtC,qCAAqC;EACrC,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,cAAc;;AAEhB","sourcesContent":[".subs .modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 0px;\n}\n\n.No-subs .modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 90%;\n  height: 90%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 0px;\n}\n\n.sw .react-switch-bg {\n  height: 22px !important;\n  width: 50px !important;\n}\n\n.sw .react-switch-handle {\n  height: 20px !important;\n  width: 20px !important;\n}\n\n.subs .modal-fullscreen {\n  height: auto !important;\n  width: 100vw !important;\n  max-width: none !important;\n  margin: 0 !important;\n}\n\n.contact-sales {\n  color: var(--Turquoise, #06EFC5);\n  font-family: Urbanist;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.897px;\n  padding: 10px;\n}\n\n.bg-img {\n  background-image: url('../../../../public/assets/images/subs-bg.png');\n  height: 100%;\n  width: 100%;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  padding: 60px;\n}\n\n.title {\n  color: var(--White, #FFF);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 1px;\n}\n\n.cross {\n  color: var(--White, #FFF);\n  font-size: 20px;\n  margin-left: auto;\n  cursor: pointer;\n}\n\n/* .sub-row {\n  align-items: center;\n} */\n\n.sub-row img {\n  width: 95px;\n}\n\n.plan {\n  color: var(--White, #FFF);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 1px;\n  margin-top: 10px;\n}\n\n.mon {\n  color: #FFF;\n  font-family: Urbanist;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 0.897px;\n}\n\n.react-switch-bg {\n  border: 1.4px white solid;\n}\n\n.sub-box {\n  width: 270px;\n  height: 100%;\n  border-radius: 8.966px;\n  border: 0.897px solid rgba(255, 255, 255, 0.10);\n  background: rgba(255, 255, 255, 0.10);\n  /* backdrop-filter: blur(2.689655303955078px); */\n  padding: 20px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.type-box {\n  border-radius: 3.586px;\n  border: 0.897px solid var(--White, #FFF);\n  padding: 8px 12px;\n}\n\n.type-box-s {\n  border-radius: 3.586px;\n  border: 0.897px solid var(--Turquoise, #06EFC5);\n  padding: 8px 12px;\n  background-color: var(--Turquoise, #06EFC5);\n}\n\n.type-box div {\n  color: var(--White, #FFF);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 0.897px;\n}\n\n.type-box-s div {\n  color: #000000;\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 0.897px;\n}\n\n.input-w {\n  position: relative;\n\n  label {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 20px;\n    height: 20px;\n    opacity: 1;\n    border: 1.5px solid rgb(255 255 255 / 40%);\n    border-radius: 4px;\n    cursor: pointer;\n\n    &:after {\n      content: \"\";\n      background-size: auto;\n      background-repeat: no-repeat;\n      background-position: center;\n      width: 18px;\n      height: 18px;\n      display: inherit;\n      top: -0.5px;\n      position: relative;\n      left: -0.6px;\n    }\n  }\n\n  input {\n    visibility: hidden;\n\n    &:checked {\n      ~label {\n        &:after {\n          background-image: url(\"data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='14' height='14' rx='2' fill='%2306EFC5'/%3E%3Cpath d='M10.765 4.20474C11.0661 4.48915 11.0797 4.96383 10.7953 5.26497L6.54526 9.76497C6.40613 9.91228 6.21332 9.99703 6.01071 9.99993C5.8081 10.0028 5.61295 9.92361 5.46967 9.78033L3.21967 7.53033C2.92678 7.23744 2.92678 6.76257 3.21967 6.46967C3.51256 6.17678 3.98744 6.17678 4.28033 6.46967L5.98463 8.17397L9.70474 4.23503C9.98915 3.9339 10.4638 3.92033 10.765 4.20474Z' fill='%23242424'/%3E%3C/svg%3E\");\n        }\n      }\n    }\n  }\n\n  &.myradio {\n    label {\n      border-radius: 50%;\n\n      &::after {\n        border-radius: 50%;\n        width: 15px;\n        height: 15px;\n        top: 1px;\n        left: 1px;\n        position: relative;\n      }\n    }\n\n    input {\n      visibility: hidden;\n\n      &:checked {\n        ~label {\n          &:after {\n            background: #0defc5;\n          }\n        }\n      }\n    }\n  }\n}\n\n.price_nav {\n  color: var(--Turquoise, #06EFC5);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 35px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.897px;\n}\n\n.price-strike_nav {\n  color: var(--Gray-6, #F2F2F2);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.897px;\n  text-decoration: line-through;\n}\n\n.time {\n  color: rgba(255, 255, 255, 0.80);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.897px;\n}\n\n.off {\n  color: #06EFC5;\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.897px;\n}\n\n.center {\n  align-items: center;\n  display: flex;\n  justify-items: flex-end;\n  justify-content: end;\n}\n\n.hr {\n  width: 90%;\n  height: 3px;\n  flex-shrink: 0;\n  border-radius: 3.586px 3.586px 0px 0px;\n  background: var(--Turquoise, #06EFC5);\n  filter: blur(0px);\n  margin-left: -20px;\n}\n\n.list-item {\n  color: #FFF;\n  font-family: Urbanist;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.list ul li ::marker {\n  display: none !important;\n}\n\n.check_nav_sub {\n  width: 100%;\n  height: 100%;\n}\n\n.list-row {\n  align-items: center;\n  display: flex;\n  justify-items: flex-end;\n}\n\n.list-add {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 40px;\n}\n\n.button1 {\n  width: 100%;\n  height: 50px;\n  flex-shrink: 0;\n  border-radius: 8.966px;\n  border: 0.897px solid #06EFC5;\n  background: linear-gradient(89deg, #242424 -261.85%, rgba(36, 36, 36, 0.00) 98.43%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n/* .button1Active {\n  width: 100%;\n  height: 50px;\n  flex-shrink: 0;\n  border-radius: 8.966px;\n  border: 0.897px solid #06EFC5;\n  background: var(--Turquoise, #06EFC5); \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  \n} */\n.button1Active {\n  width: 100%;\n  height: 50px;\n  flex-shrink: 0;\n  border: 0.9px solid #06EFC5;\n  border-radius: 8.97px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: white;\n  font-weight: 500;\n  background-color: transparent;\n}\n.button1Active:hover{\n  background: var(--Turquoise, #06EFC5);\n  color: #000000;\n}\n\n.btn-txt {\n  color: var(--ds-neural-03, #FFF);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 0.14px;\n}\n\n\n.btn-continue {\n  border-radius: 10px;\n  background: #06EFC5;\n  /* filter: blur(2px); */\n  display: flex;\n  width: 40%;\n  height: 56px;\n  padding: 13px 49px;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  box-shadow: 0px 2px 24px 0px rgba(16, 155, 255, 0.24);\n  cursor: pointer;\n}\n\n.cont {\n  color: #100027;\n  text-align: center;\n  font-family: Open Sans;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.165px;\n}\n\n.cards-row {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n}\n\n.justify-cent {\n  justify-content: center;\n}\n\n.noSub {\n  width: 500px;\n  font-size: 16px;\n  color: #FFFFFF;\n  font-weight: 500;\n}\n\n@media screen and (min-width:750px) and (max-width:900px) {\n  .cards-row {\n    justify-content: unset;\n    overflow: auto;\n  }\n}\n\n@media screen and (min-width:350px) and (max-width:740px) {\n  .cards-row {\n    justify-content: unset;\n    overflow: auto;\n  }\n\n  .bg-img {\n    padding: 20px;\n  }\n\n  .justify-cent {\n    justify-content: unset;\n    align-items: center;\n  }\n\n  .mon {\n    font-size: 15px;\n  }\n\n  .column-three {\n    order: 3;\n    margin-top: 10px;\n  }\n\n  .title {\n    font-size: 26px;\n    margin-top: 10px;\n  }\n}\n@media screen and (max-width: 540px) {\n  .main-div{\n    display: block !important;\n  }\n  .col-md-5.col-6.p-0 {\n      flex: 0 0 41.666667%;\n      max-width: 100%;\n  }\n  .subs-year-text{\n    margin-top: 0px !important;\n    width: 140px !important;\n    margin: 0px auto !important;\n    padding-bottom: 20px !important;\n  }\n  .type-box{\n    width: 100px !important;\n  }\n  .list-add{\n    /* flex-direction: row; */\n    margin-left: 5px;\n    /* margin-top: 20px; */\n  }\n  .one{\n    top: 62% !important;\n    left: 24%;\n    margin-left: -26px !important;\n  }\n  /* .navSubscription{\n   width: 100% !important;\n  } */\n  .list-item{\n    font-size: 13px;\n  }\n  .margn-top38{\n    padding: 0px !important;\n  }\n}\n.price-wise {\n  color: rgba(255, 255, 255, 0.80);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.0625rem;\n}\n\n.navSubscription {\n  margin-top: 28px !important;\n  margin-bottom: 28px !important;\n  border-radius: 8.966px;\n  border: 0.897px solid rgba(255, 255, 255, 0.10);\n  background: rgba(255, 255, 255, 0.10);\n  backdrop-filter: blur(2.689655303955078px);\n}\n.selectedSubscription {\n  margin-top: 28px !important;\n  margin-bottom: 28px !important;\n  border-radius: 8.97px;\n  border: 0.9px solid #06EFC5;\n  background: rgba(255, 255, 255, 0.10);\n  backdrop-filter: blur(2.689655303955078px);\n}\n.promoCode{\n  width: fit-content;\n  margin: 10px auto;\n}\n.promo-code{\n  background: transparent;\n  border-color: #FFFFFF;\n  border-radius: 5px; \n  background: rgba(255, 255, 255, 0.10);\n  backdrop-filter: blur(2.689655303955078px);\n  font-size: 16px;\n  padding: 7px 30px;\n  color: #FFFFFF;\n}\n.promo-code::placeholder{\n  color: #9A9A9A;\n}\ninput[type=radio]#radio { \n  width: 15px;\n  height: 15px;\n  accent-color: #06EFC5; \n} \n.heading{\n  color: #06EFC5;\n  font-size: 16px;\n  width: fit-content;\n  padding: 10px 0px 0px 10px;\n}\n.price-details{\n  display: flex;\n  justify-content: space-between;\n  padding: 7px 0px;\n}\n.price-details-text{\n  color: #FFF;\n  font-size: 12px;\n  font-weight: 300;\n}\n.btn_extra1 {\n  color: var(--Turquoise, #06EFC5);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: -0.165px;\n}\n\n.btn_extra2 {\n  color: var(--Turquoise, #06EFC5);\n  text-align: right;\n  font-family: Urbanist;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.165px;\n}\n\n.navSubsCardTitle {\n  margin-top: 1rem;\n  color: var(--White, #FFF);\n  font-family: Urbanist;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 1px;\n  display: flex;\n  align-items: center;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.10);\n  backdrop-filter: blur(2.689655303955078px);\n  margin-left: 10px;\n}\n\n.dotActive {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--Turquoise, #06EFC5);\n  backdrop-filter: blur(2.689655303955078px);\n  margin-left: 10px;\n}\n\n.divPointer {\n  cursor: pointer;\n}\n\n.hrcard {\n  width: 100%;\n  height: 3px;\n  flex-shrink: 0;\n  border-radius: 3.586px 3.586px 0px 0px;\n  background: var(--Turquoise, #06EFC5);\n  filter: blur(0px);\n  /* margin-left: -20px; */\n}\n\n/* .button1Active {\n  width: 100%;\n  height: 50px;\n  flex-shrink: 0;\n  border-radius: 8.966px;\n  border: 0.897px solid #06EFC5;\n  background: var(--Turquoise, #06EFC5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n} */\n\n.btn-txtActive {\n  color: black;\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 0.14px;\n}\n.cancel-sub-box{\n  background-color: #30273E;\n  border-radius:12px;\n}\n.cancel-heading{\n    color: var(--White, #FFF);\n    text-align: center;\n    font-family: Urbanist;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 1px;\n}\n.cancel-sub-subHeading{\n  color: var(--White, #FFF);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 1px;\n  opacity: 0.8;\n}\n.cancel-sub-terms{\n  color: var(--White, #FFF);\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 1px;\n  opacity: 0.8;\n}\n.cancel-sub-terms span{\n  text-decoration-line: underline;\n}\n.cancel-sub-btn-cancel{\n  cursor:pointer;\n  opacity: 0.44;\n}\n.cancel-sub-btn-confirm{\n  cursor:pointer;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius:12px;\n}\n.cancel-sub-btn span{\n  color: var(--White, #FFF);\n  text-align: center;\n  font-family: Open Sans;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.165px;\n}\n.cancel-sub-btn span.confirm{\n  color: #EB5757;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
